import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ButtonMenu, ButtonMenuItem, Flex } from 'vvs-uikit'

import { useTranslation } from 'contexts/Localization'

const SubNav = () => {
  const location = useLocation()
  const { t } = useTranslation()

  let activeIndex
  switch (location.pathname) {
    case '/dashboard/farm':
      activeIndex = 0
      break;
    case '/dashboard/mine':
      activeIndex = 1
      break;
    case '/dashboard/liquidity':
      activeIndex = 2
      break;
    default:
      activeIndex = 0;
  }

  return (
    <Flex justifyContent="center" mb={24}>
      <ButtonMenu activeIndex={activeIndex} scale="sm" variant="primary">
        <ButtonMenuItem to="/dashboard/farm" as={Link} padding="20px 30px">
          {t('My Farms')}
        </ButtonMenuItem>
        <ButtonMenuItem to="/dashboard/mine" as={Link} padding="20px 30px">
          {t('My Mines')}
        </ButtonMenuItem>
        <ButtonMenuItem to="/dashboard/liquidity" as={Link} padding="20px 30px">
          {t('My Liquidity')}
        </ButtonMenuItem>
      </ButtonMenu>
    </Flex>
  )
}

export default SubNav
